import { render, staticRenderFns } from "./PedidosAdmin.vue?vue&type=template&id=588a7a13"
import script from "./PedidosAdmin.vue?vue&type=script&lang=js"
export * from "./PedidosAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports